import React from 'react'
import { Container, Row, Col } from 'reactstrap'
import { useLocation } from 'react-router-dom'
import './style/style.scss'

export const SSOFailure = () => {
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const s = queryParams.get('s')

  const getErrorMessage = status => {
    switch (status) {
      case '400':
        return {
          title: 'Bad Request (400)',
          message: 'The request was invalid.',
          cta1: 'Please contact Centivo at',
          cta2: 'for assistance.',
        }
      case '401':
        return {
          title: "We couldn't confirm your access (401)",
          message:
            'We couldn’t verify your access. We’re missing your TIN information or you’re not a contracted provider in the Centivo Network.',
          cta1: 'Please contact Centivo at',
          cta2: 'for assistance.',
        }
      case '500':
        return {
          title: 'Unexpected system error (500)',
          message:
            'Something went wrong on our end. We are experiencing a temporary system issue or a service we rely on is not responding correctly. Please try again in 15 minutes.',
          cta1: 'If your issue persists, please contact Centivo at',
          cta2: 'for assistance.',
        }
      default:
        return {
          title: 'Unexpected system error',
          message:
            'Something went wrong on our end. We are experiencing a temporary system issue or a service we rely on is not responding correctly. Please try again in 15 minutes.',
          cta1: 'If your issue persists, please contact Centivo at',
          cta2: 'for assistance.',
        }
    }
  }

  const errorMessage = getErrorMessage(s)

  return (
    <Container className="auth">
      <Row>
        <Col>
          <h2 className="header head-1">{errorMessage.title}</h2>
          <p className="text-normal margin-top-40 padding-bottom-40">
            {errorMessage.message}
          </p>
          <p className="text-center">
            {errorMessage.cta1}{' '}
            <a href="mailto:providerrelations@centivo.com">
              providerrelations@centivo.com
            </a>{' '}
            {errorMessage.cta2}
          </p>
        </Col>
      </Row>
    </Container>
  )
}
